import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height='64'
      width='64'
      viewBox='0 0 64 64'
    >
      <path d='M32 2.9c-8.7 0-15.8 7.1-15.8 15.8S23.3 34.4 32 34.4s15.8-7.1 15.8-15.8S40.7 2.9 32 2.9zm0 37c-10.3 0-19.9 5.1-25.7 13.5-1.2 1.7-1.7 3.7-1.7 5.8 0 1.1 1 2 2.1 2h50.7c1.1 0 2.1-.9 2.1-2 .1-2.1-.5-4.1-1.7-5.8-5.9-8.5-15.5-13.5-25.8-13.5z'/>
    </svg>
  );
}

export default Icon;
